import { useCallback, useState } from "react";

function readStored(key: string): boolean {
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

function writeStored(key: string, collapsed: boolean): void {
  try {
    localStorage.setItem(key, collapsed ? "1" : "0");
  } catch {
    /* private mode / quota */
  }
}

/** Persists sidebar collapsed preference in localStorage. */
export function usePersistedSidebarCollapsed(storageKey: string) {
  const [collapsed, setCollapsedState] = useState(() => readStored(storageKey));

  const setCollapsed = useCallback(
    (next: boolean) => {
      setCollapsedState(next);
      writeStored(storageKey, next);
    },
    [storageKey]
  );

  const toggleCollapsed = useCallback(() => {
    setCollapsed(!collapsed);
  }, [collapsed, setCollapsed]);

  return { collapsed, setCollapsed, toggleCollapsed };
}
